import React from "react";

export const UserIcon: React.FC<any> = ({
  width = 512,
  height = 512,
  fill = "#000",
}) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path
        d="M12.0009 17.5C15.6633 17.5 18.8659 19.0751 20.608 21.4247L18.766 22.296C17.3482 20.6157 14.8483 19.5 12.0009 19.5C9.15346 19.5 6.6535 20.6157 5.23577 22.296L3.39453 21.4238C5.13673 19.0747 8.33894 17.5 12.0009 17.5ZM12.0009 2.5C14.7623 2.5 17.0009 4.73858 17.0009 7.5V10.5C17.0009 13.1888 14.8786 15.3818 12.2178 15.4954L12.0009 15.5C9.23945 15.5 7.00087 13.2614 7.00087 10.5V7.5C7.00087 4.81125 9.12318 2.61818 11.784 2.50462L12.0009 2.5ZM12.0009 4.5C10.4032 4.5 9.09721 5.74892 9.00596 7.32373L9.00087 7.5V10.5C9.00087 12.1569 10.344 13.5 12.0009 13.5C13.5986 13.5 14.9045 12.2511 14.9958 10.6763L15.0009 10.5V7.5C15.0009 5.84315 13.6577 4.5 12.0009 4.5Z"
        fill={fill}
      />
    </svg>
  );
};

export const RightArrow: React.FC<any> = ({
  width = 512,
  height = 512,
  fill = "#000",
}) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path
        d="M14.83 11.7897L10.59 7.5497C10.497 7.45598 10.3864 7.38158 10.2646 7.33081C10.1427 7.28004 10.012 7.25391 9.88 7.25391C9.74799 7.25391 9.61728 7.28004 9.49542 7.33081C9.37356 7.38158 9.26296 7.45598 9.17 7.5497C8.98375 7.73707 8.87921 7.99052 8.87921 8.2547C8.87921 8.51889 8.98375 8.77234 9.17 8.9597L12.71 12.4997L9.17 16.0397C8.98375 16.2271 8.87921 16.4805 8.87921 16.7447C8.87921 17.0089 8.98375 17.2623 9.17 17.4497C9.26344 17.5424 9.37426 17.6157 9.49609 17.6655C9.61793 17.7152 9.74839 17.7405 9.88 17.7397C10.0116 17.7405 10.1421 17.7152 10.2639 17.6655C10.3857 17.6157 10.4966 17.5424 10.59 17.4497L14.83 13.2097C14.9237 13.1167 14.9981 13.0061 15.0489 12.8843C15.0997 12.7624 15.1258 12.6317 15.1258 12.4997C15.1258 12.3677 15.0997 12.237 15.0489 12.1151C14.9981 11.9933 14.9237 11.8827 14.83 11.7897Z"
        fill={fill}
      />
    </svg>
  );
};

export const AddressIcon: React.FC<any> = ({
  width = 512,
  height = 512,
  fill = "#000",
}) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path
        d="M21 19.5H23V21.5H1V19.5H3V4.5C3 3.94772 3.44772 3.5 4 3.5H14C14.5523 3.5 15 3.94772 15 4.5V19.5H19V11.5H17V9.5H20C20.5523 9.5 21 9.94772 21 10.5V19.5ZM5 5.5V19.5H13V5.5H5ZM7 11.5H11V13.5H7V11.5ZM7 7.5H11V9.5H7V7.5Z"
        fill={fill}
      />
    </svg>
  );
};

export const AddIcon: React.FC<any> = ({
  width = 512,
  height = 512,
  fill = "#000",
}) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M19 11H13V5C13 4.73478 12.8946 4.48043 12.7071 4.29289C12.5196 4.10536 12.2652 4 12 4C11.7348 4 11.4804 4.10536 11.2929 4.29289C11.1054 4.48043 11 4.73478 11 5V11H5C4.73478 11 4.48043 11.1054 4.29289 11.2929C4.10536 11.4804 4 11.7348 4 12C4 12.2652 4.10536 12.5196 4.29289 12.7071C4.48043 12.8946 4.73478 13 5 13H11V19C11 19.2652 11.1054 19.5196 11.2929 19.7071C11.4804 19.8946 11.7348 20 12 20C12.2652 20 12.5196 19.8946 12.7071 19.7071C12.8946 19.5196 13 19.2652 13 19V13H19C19.2652 13 19.5196 12.8946 19.7071 12.7071C19.8946 12.5196 20 12.2652 20 12C20 11.7348 19.8946 11.4804 19.7071 11.2929C19.5196 11.1054 19.2652 11 19 11Z"
        fill={fill}
      />
    </svg>
  );
};
